// import SidebarMainLogo from "../assets/images/logos/TriloDocs-Logo-Stacked-POSITIVE.png";
import React, { forwardRef } from "react";
import { NavLink } from "react-router-dom";
import { ReactComponent as DashboardIcon } from "../assets/images/icons/dashboard.svg";
import { ReactComponent as ProfileIcon } from "../assets/images/icons/profile.svg";
import ProfilePopup from "./ProfilePopup";
import ClickOutsideHelper from "../utils/ClickOutsideHelper";
import HubspotForm from "./HubspotForm";

const SidebarMain = forwardRef(({ open, setOpen }, ref) => {
  const handleProfileClick = e => {
    e.preventDefault();
    setOpen(!open);
  };

  return (
    <div className={"sidebar__main"}>
      <div className={"center"}>
        <ul>
          <li>
            <NavLink to={"/dashboard"}>
              <DashboardIcon />
            </NavLink>
          </li>
          <li ref={ref} className={"profile-link"}>
            <button
              onClick={handleProfileClick}
              className={`link-button ${open ? "active" : ""}`}>
              <ProfileIcon />
            </button>
            {open && <ProfilePopup />}
          </li>
          <li>
            <HubspotForm
              region={process.env.REACT_APP_HUBSPOT_REGION}
              portalId={process.env.REACT_APP_HUBSPOT_PORTALID}
              formId={process.env.REACT_APP_HUBSPOT_FORMID}
              trigger={
                <button className="feedback-button">Contact Support</button>
              }
            />
          </li>
        </ul>
      </div>
    </div>
  );
});

SidebarMain.displayName = "SidebarMain";
export default ClickOutsideHelper(SidebarMain);
